import { Component, Input, trigger, state, style,
  transition, animate } from '@angular/core';


@Component({
  selector: 'card-collapse',
  templateUrl: 'card-collapse.html',
  animations: [
    trigger('animState', [
      state('closed', style({
        height: '0',
        display: 'none'
      })),
      state('open', style({
        height: '*',
        display: 'block'
      })),
      transition('closed => open', animate('300ms ease-in')),
      transition('open => closed', animate('300ms ease-out'))
    ])
  ]
})
export class CardCollapse {

  @Input() state: string = "open";
  @Input() title: string = "";
  @Input() icon: string = "";

	collapse() {
    this.state = (this.state == "open" ? "closed" : "open");
	}

}



// WEBPACK FOOTER //
// ./src/components/card-collapse/card-collapse.component.ts